import Vue from 'vue';

import VueRouter from 'vue-router';
import {
    ValidationProvider, ValidationObserver,
} from 'vee-validate';

import App from './App.vue';
import i18n from './i18n';
import router from './router';
import store from './store';
import helpers from './helpers';
import './directives';

import '@/assets/scss/base.scss';

const plugin = {
    install() {
        Vue.helpers = helpers;
        Vue.prototype.$helpers = helpers;
    },
};
window.axios = require('axios');

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.use(VueRouter);
Vue.use(plugin);

new Vue({
    render: (h) => h(App),
    router,
    store,
    i18n,
}).$mount('#app');
